import React from 'react';
import PropTypes from 'prop-types';
import { generateMetricsAttribute } from '@sm/metrics';
import { createURL } from '@sm/utils';
import { Box } from '@wds/box';
import { Card } from '@wds/card';
import { Typography } from '@wds/typography';
import AppPlaceHolderImg from '~app/pages/AppsDirectory/static/images/app-placeholder.png';
import { trimStringTo } from '~app/pages/AppsDirectory/components/utils';
import useStyles from './styles';

const AppCard = ({ app, isFeatured }) => {
  const { appCardLogo } = useStyles();
  const href = createURL(app.link);

  const metricsInteractionLocation = `${isFeatured ? 'featured ' : ''}integration tile`;

  return (
    <Card
      data-testid="AppCard__Col"
      key={app.encryptedAppId}
      href={href}
      data-sm-metrics={generateMetricsAttribute({
        data: {
          amplitudeEvent: 'app directory user interaction',
          interactionType: 'click',
          interactionLocation: metricsInteractionLocation,
          appName: app.name,
        },
      })}
    >
      <Card.Preview>
        <Box mb={5}>
          <img src={app.image ? app.image : AppPlaceHolderImg} alt={app.name} className={appCardLogo} />
        </Box>
      </Card.Preview>
      <Card.Header>
        <Typography variant="cardTitle" weight="medium">
          {app.name}
        </Typography>
      </Card.Header>
      <Card.Body>
        <Typography>{trimStringTo(85, app.tagline)}</Typography>
      </Card.Body>
    </Card>
  );
};

AppCard.defaultProps = {
  isFeatured: false,
};

AppCard.propTypes = {
  app: PropTypes.shape({
    encryptedAppId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    tagline: PropTypes.string.isRequired,
    image: PropTypes.string,
    link: PropTypes.string.isRequired,
  }).isRequired,
  isFeatured: PropTypes.bool,
};

export default AppCard;
